import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, TemplateRef } from '@angular/core';

import { TranslatePipe } from '@recruitee/i18n';

import { IconName } from '../../icons-container/icons.type';
import { AvatarComponent } from '../avatar/avatar.component';
import { AvatarSize } from '../avatar/avatar.types';
import { BadgeComponent } from '../badge/badge.component';
import { HeadingComponent } from '../heading/heading.component';
import { IconColorDirective, IconToken } from '../icon/directives/icon-color.directive';

export type ProviderStatus =
  | string
  | 'connected'
  | 'pending'
  | 'disconnected'
  | 'inactive'
  | 'initial';

@Component({
  selector: 'rt-provider-item',
  templateUrl: './provider-item.component.html',
  styleUrls: ['./provider-item.component.less'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgTemplateOutlet,
    AvatarComponent,
    HeadingComponent,
    IconColorDirective,
    BadgeComponent,
    TranslatePipe,
  ],
})
export class ProviderItemComponent {
  @Input({ required: false }) public header?: string;
  @Input() public headerTpl: TemplateRef<any> | null;
  @Input() public description: string | null;
  @Input() public descriptionTpl: TemplateRef<any>;
  @Input() public icon: IconName;
  @Input() public imageSrc: string | null;
  @Input() public iconSize: AvatarSize = 'base';
  @Input() public iconToken: IconToken = 'colorIconDefault';
  @Input() public status: ProviderStatus;
  @Input() public initials: string;
  @Input() public compact: boolean = false; // compact version for narrow containers, e.g getting-started-drawer
}
